import PageFrame from 'components/PageFrame/PageFrame'
import TrackView from 'views/TrackView/TrackView'
import PlaylistView from 'views/PlaylistView/PlaylistView'
import {
  usePlaylistsQuery,
  useTracksQuery,
  useUpdatePlayerMutation,
  useUpdatePlaylistsMutation,
  useUpdateTrackMutation,
  useUpdateTracksMutation,
} from 'api/api'
import { useEffect, useState } from 'react'
import useDebounce from 'utils/hooks/useDebounce'
import BulkTrackView from '../TrackView/BulkTrackView'
import TracksView from '../TracksView/TracksView'
import DndProviderWrapper from '../../components/DndProviderWrapper/DndProviderWrapper'

const LibraryView = ({}) => {
  const [tracksToEdit, setTracksToEdit] = useState([])

  const { data: playlistsData, isFetching: playlistsIsFetching } =
    usePlaylistsQuery()
  const { data: tracksData } = useTracksQuery()
  const [updateTrack, { isLoading: updateTrackIsLoading }] =
    useUpdateTrackMutation()
  const [updateTracks, { isLoading: updateTracksIsLoading }] =
    useUpdateTracksMutation()
  const [updatePlaylists, { isLoading: playlistsIsLoading }] =
    useUpdatePlaylistsMutation()
  const debouncedUpdatePlaylists = useDebounce(2000)
  const [playlistOutOfDate, setPlaylistOutOfDate] = useState(false)
  const [updatePlayer, { isLoading: updatePlayerIsLoading }] =
    useUpdatePlayerMutation()

  const tracks = tracksData?.data || []

  function handleSaveTrack(values) {
    updateTrack({ id: values.id, values })
  }

  function handlePlaylistsSave(data, saveFlags = {}) {
    const defaultFlags = {
      debounced: true,
    }
    const flags = {
      ...defaultFlags,
      ...saveFlags,
    }

    setPlaylistOutOfDate(true)
    if (flags.debounced) {
      debouncedUpdatePlaylists(() => {
        handleSave(data, flags)
      })
    } else {
      handleSave(data, flags)
    }
  }

  function handleSave(data, flags) {
    updatePlaylists(data).then((res) => {
      if (flags?.publish && flags?.playlistId) {
        updatePlayer(flags?.playlistId)
      }
    })
    setPlaylistOutOfDate(false)
  }

  function handleEditPlaylistTrack(trackId) {
    const track = tracks.find((item) => item.id === trackId)
    setTracksToEdit([track])
  }

  function handleTrackCancel(evt) {
    setTracksToEdit([])
    evt.stopPropagation()
  }

  function handleBulkSave(values) {
    updateTracks({ ids: tracksToEdit.map((track) => track.id), values })
  }

  return (
    <PageFrame route="library" showBanner>
      <DndProviderWrapper className="flex flex-row h-full p-4" disableBuffer>
        <div className="min-w-[500px] max-w-[700px] h-full pr-2 w-full ">
          <div className="flex rounded-t h-[50px] px-6 items-center bg-purple-light dark:bg-deep text-white">
            <h5>Tracks</h5>
          </div>
          <div className="bg-white-purple dark:bg-gray-light h-[calc(100%-50px)] pb-4 rounded-b">
            <TracksView
              onEditTracks={setTracksToEdit}
              onModalClick={handleTrackCancel}
              lockSelections={tracksToEdit.length > 0}
            />
          </div>
        </div>

        <div className="flex-1 relative pl-2">
          <div className="flex rounded-t h-[50px] px-6 items-center bg-purple-light dark:bg-deep text-white">
            <h5>Playlists</h5>
          </div>
          <div className="bg-white-purple dark:bg-gray-light h-[calc(100%-50px)] pb-4 rounded-b">
            <PlaylistView
              isLoading={
                playlistsIsFetching ||
                playlistsIsLoading ||
                updatePlayerIsLoading
              }
              isOutOfDate={playlistOutOfDate}
              playlist={playlistsData}
              onSubmit={handlePlaylistsSave}
              onEditTrack={handleEditPlaylistTrack}
            />
          </div>
        </div>
        {tracksToEdit.length === 1 && (
          <div className="absolute w-[calc(100%-60px)] flex h-full top-0 right-0 z-10">
            <button
              className="flex-1 bg-[#000000cc]"
              onClick={handleTrackCancel}
            ></button>
            <div className="h-full top-0 w-[60vw] min-w-[800px] right-0">
              <TrackView
                isLoading={updateTrackIsLoading}
                track={tracksToEdit[0]}
                onSubmit={handleSaveTrack}
                onCancel={handleTrackCancel}
              />
            </div>
          </div>
        )}
        {tracksToEdit.length > 1 && (
          <div className="absolute w-[calc(100%-60px)] flex h-full top-0 right-0 z-10">
            <button
              className="flex-1 bg-[#000000cc]"
              onClick={handleTrackCancel}
            ></button>
            <div className="h-full top-0 w-[60vw] min-w-[800px] right-0">
              <BulkTrackView
                isLoading={updateTracksIsLoading}
                tracks={tracksToEdit}
                onSubmit={handleBulkSave}
                onCancel={handleTrackCancel}
              />
            </div>
          </div>
        )}
      </DndProviderWrapper>
    </PageFrame>
  )
}

export default LibraryView
